import React, { Component } from 'react';

class PastilleInteret extends Component {
  render() {
    return <div className={'pastille round lvl-' + this.props.niveau}>{this.props.niveau}</div>
  }
}

export default PastilleInteret;
